/**
 * Toggles the visibility of a dropdown menu and hides all other dropdowns on the page.
 * @param {Event} event - The event object.
 */

import { trapFocus } from "../helpers/trapFocus.js";
// import { handleEscKey } from "../helpers/handleEscape.js";

export function toggleDropdown(event) {
    const dropdown = event.target.closest(".dropdown");

    if (dropdown) {
        const allDropdowns = document.querySelectorAll(".dropdown");
        allDropdowns.forEach((otherDropdown) => {
            if (otherDropdown !== dropdown) {
                const menu = otherDropdown.querySelector('ul[role="list"]');
                if (menu) {
                    menu.hidden = true;
                    otherDropdown.classList.remove("is-open");
                }
            }
        });

        const menu = dropdown.querySelector('ul[role="list"]');
        if (menu) {
            menu.hidden = !menu.hidden;
            dropdown.classList.toggle("is-open");
            trapFocus(dropdown);
        }
    }
}

const dropdownButtons = document.querySelectorAll(".dropdown button.btn");

dropdownButtons.forEach((button) => {
    button.addEventListener("click", toggleDropdown);
});

// const dropdownConfig = {
//     openSelector: ".dropdown.is-open",
//     menuSelector: 'ul[role="list"]',
//     openClass: "is-open",
//     focusSelector: "button.btn",
// };

// document.addEventListener("keydown", (event) =>
//     handleEscKey(event, dropdownConfig),
// );
